'use strict';

import Axios from "axios";
import Api from "./Api";

export default class Auth extends Api {

    static login(email, password) {
        const url = this.url + 'auth/login';

        return Axios.post(url, {
            email: email,
            password: password,
        });
    }

}